<template>
  <div>
    <v-navigation-drawer 
      v-model="sideNav" 
      absolute 
      width="150" 
      temporary>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title @click="$router.push('/')">Voice portal</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        
      <v-list class="dense">
        <v-list-tile v-for="item in hambItems" :key="item.title" :to="item.link" @click="setType(item.title)">
          <v-list-tile-content>{{item.title}}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="logOut">Log out</v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app dense class="secondary ">
      <v-toolbar-side-icon @click.stop="sideNav = !sideNav" class="menu mr-1 white--text" />
      <v-toolbar-title class="brand mr-5"> <router-link to='/' tag="span" style="cursor: pointer">Voice Portal</router-link></v-toolbar-title>
      <v-spacer/>

        <v-menu v-if="!isAdmin" :nudge-width="40">
          <v-toolbar-title slot="activator" class="menu">
            <span class="mr-1 white--text">YOUR STUFF</span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-toolbar-title>
  
          <v-list class="dense">
            <v-list-tile v-for="item in dropdownItems" :key="item.title" :to="item.link" @click="setType(item.title)">
              <v-list-tile-content>{{item.title}}</v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>

      <v-toolbar-items class="hidden-xs-only nv">
        <v-btn flat v-for="item in topNavItems"
          :key="item.title"
          :to="item.link"
          class="white--text"
          @click="setType(item.title)">
          {{item.title}}
        </v-btn>
        <v-btn flat class="white--text" @click="logOut">Log out</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>

</template>

<script>
import router from "../router/index"
import { mapState } from "vuex"
export default {
  data() {
    return {
      sideNav: null,
    }
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.userId === this.$store.state.adminId
    },
    topNavItems() {
      let menuItems = []

      if (!this.isAdmin) {
        menuItems = [{ title: "Book lessons", link: "/lessonsDisplay" }]
      } else {
        menuItems = [
          { title: "Admin", link: "/admin" },
        ]
      }
      return menuItems
    },
    hambItems() {
      let hambItems = []

      if (!this.isAdmin) {

        hambItems = [
          { title: "Your songlist", link: '/editSonglist' },
          { title: "Tracks, songs, and exercises", link: "/downloads" },
          { title: "Dryboard notes", link: "/downloads" },
          { title: "Handouts", link: "/downloads" },
          { title: "Final Tracks", link: "/downloads" },
          { title: "Targeted-Exercises", link: "/exercises" },
          { title: "Book lessons", link: "/lessonsDisplay" }
        ]
      } else {
        hambItems = [
          { title: "Admin", link: "/admin" },
        ]
      }
      return hambItems
    },
    dropdownItems() {
      let sbLink = '/songbooks'

      let dropdownItems = [
        { title: "Your songlist", link: "/editSonglist" },
        { title: "Tracks, songs, and exercises", link: "/downloads" },
        { title: "Dryboard notes", link: "/downloads" },
        { title: "Handouts", link: "/downloads" },
        { title: "Final Tracks", link: "/downloads" },
        { title: "Targeted-Exercises", link: "/exerciseList" }
      ]
      return dropdownItems
    }
  },
  methods: {
    logOut() {
      this.$store.commit("clearUser")
      this.$router.replace("/signin")
    },
    setType(type) {
      if (type === "Admin") {
        return
      }
      this.$store.dispatch("setType", type)
    }
  }
}
</script>

<style scoped>
.white--text {
  font-size: 13px;
}
.brand {
  font-family: "Cormorant", serif;
  font-size: 20px;
  font-weight: 600;
  color: whitesmoke;
  margin: 0;
  padding: 0;
}

.nv {
  font-family: "Cormorant", serif;
  font-weight: 600;
}

.menu {
  display: flex;
  align-items: center;
  font-family: "Cormorant", serif;
  font-size: 13px;
  margin: 0;
}
</style>